<style lang="sass" scoped>
@use "./style/index" as *

.questions_box
  position: relative
  display: flex
  flex-direction: column
  height: calc(var(--vh, 1vh) * 100 - 46px)

.title
  padding-bottom: 16px
  text-overflow: ellipsis
  white-space: nowrap
  border-radius: 18PX 18PX 0 0
  line-height: 35PX
  font-size: 16px
  text-align: center
  overflow: hidden
  background: #fff
  z-index: 2
  background: #f3f3f3
  border-bottom: 1px solid rgba(50, 56, 62, 0.1)

  &.only_one_title
    padding-bottom: 0
    overflow: visible

  .label_text
    display: flex
    justify-content: center
    padding: 4px 0px
    font-size: 12px
    letter-spacing: 0.5px

  .progress_box
    padding: 0 20px

  .label_box
    position: absolute
    top: 51px
    left: 0
    right: 0
    padding: 0px 20px
    background: #f3f3f3
    border-bottom: 1px solid #e3e3e4

    .prompt_title
      margin: 20px 0 16px 0
      font-size: 22px
      font-weight: 900
      line-height: 26px

    .prompt_text
      margin-bottom: 20px
      font-size: 14px
      font-weight: 400
      line-height: 17px

    &.only_label
      top: 0

.component_box
  position: relative
  flex: 1
  overflow: auto

.footer
  position: absolute
  top: 0
  display: flex
  justify-content: space-around
  align-items: center
  width: 100vw
  height: 94px
  border-top: 1px solid #e8e8e9
  background: #fff
  font-weight: bold

  .footer_button
    width: calc(100vw - 30PX)

  .footer_another
    width: 45%
    border-radius: 4px !important
    overflow: hidden

    ::v-deep
      .van-button__text
        white-space: pre-wrap

.index
  position: absolute
  top: 0
  width: 100%

.button
  position: absolute
  display: block
  width: 16px
  top: 0
  right: 50%
  margin-right: -8px
  font-weight: Bold

.button_box
  position: relative
  height: 94px

.text_span
  position: relative
  display: block
  width: 20px
  height: 12px

.text_right
  margin-left: 6px
  font-weight: Bold

.labelBox_margin
  margin-top: var(--labelBoxHeight)

.wrapper
  position: relative
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 10px
  height: 500px
  width: 300px
  overflow: auto

.block
  display: flex
  flex-direction: column
  flex: 1
  width: 100%
  margin-top: 26px
  background-color: #fff
  overflow: auto
  border-radius: 10px

  ::v-deep
    *
      white-space: pre-wrap !important

.close_icon
  position: absolute
  top: 8px
  right: 8px
  color: var(--menu-primary-background-colour) !important
  cursor: pointer

.theme_color
  color: var(--menu-primary-background-colour) !important

.review_btn_text
  vertical-align: middle

.review_btn_g
  width: 22px
  height: 22px
  margin-left: 6px
  vertical-align: middle

::v-deep
  .van-popup
    border-radius: 18px !important

#progress
  height: 10px
  border-radius: 15px
  overflow: hidden
  background: rgba(50, 56, 62, 0.15)

#progress span
  display: flex
  height: 10px
  background: var(--menu-primary-background-colour)
  color: #fff
  transition: width .5s
  border-radius: 15px
</style>

<template lang="pug">
.questions_box
  .title(:class="{ 'only_one_title': componentNameArrLength === 1 }")
    .label_text(v-if="componentNameArrLength > 1") {{ t('question', 'QUESTION') }}
      span.text_span
        transition(name="button")
          span.button(v-if="isShow" key="1") {{ indexCombo + 1 }}
          span.button(v-else) {{ indexCombo + 1 }}
      span {{ t('of', 'OF') }}
      span.text_right {{ componentNameArrLength }}

    .progress_box(v-if="componentNameArrLength > 1")
      #progress
        span(:style="{ width: progressTotal + '%' }")

    transition(name="label")
      .label_box(v-if="(!indexCombo || alwaysShowHeader) && (showMessageList.title !== ' ')" :class="{ 'only_label': componentNameArrLength === 1 }" ref="labelBox")
        .prompt_title {{ isReviewHero ? reviewHeaderText : (showMessageList.title ? showMessageList.title : t('thank_you_for_order', 'Thank you for your order!')) }}
        .prompt_text {{ showMessageList.titleLong ? showMessageList.titleLong : t('please_answer_questions', 'Please take a moment to answer the following questions.') }}

  .component_box
    transition
      component.index(
        v-if="showComponentBox"
        key="1"
        ref="component"
        :class="{ 'labelBox_margin': !indexCombo && showMessageList.title !== ' ' }"
        :style="{ '--labelBoxHeight': labelBoxHeight }"
        :is="componentsName + '-components'"
        :index="indexCombo"
        :data="questionData"
        :imgSrc="imgSrc"
        :marketingConsentMessage="marketingConsentMessage"
        @event="event"
        @open="openCampaign"
      )
      component.index(
        v-else
        ref="component"
        :class="{ 'labelBox_margin': !indexCombo }"
        :style="{ '--labelBoxHeight': labelBoxHeight }"
        :is="componentsName + '-components'"
        :index="indexCombo"
        :data="questionData"
        :imgSrc="imgSrc"
        :marketingConsentMessage="marketingConsentMessage"
        @event="event"
        @open="openCampaign"
      )

  .button_box(:style="bottomButtonStyle")
    transition-group(name="button")
      .footer(
        v-if="isCampaigns !== 1 || (questionData && questionData.type !== 'campaign') || indexCombo !== 0"
        :key="1"
        ref="footer"
      )
        van-button.footer_button(
          size="large"
          type="primary"
          :disabled="disabled"
          @click="switchComponent(true)"
        ) {{ buttonText }}

      .footer(v-if="questionData && (questionData.type === 'campaign')" :key="2")
        van-button.footer_another.theme_color(
          size="large"
          @click="switchComponent(false)"
        ) {{ rejectButtonText }}

        van-button.footer_another(
          size="large"
          type="primary"
          @click="focusDialog('campaign', localizedOptinText, localizedOptinTitle)"
        )
          template(v-if="isReviewHero")
            span.review_btn_text {{ reviewBtnText }}
            img.review_btn_g(src="@/assets/icon/google-g.svg" v-if="questionData.settings.campaign.icon !== 'review'")
          template(v-else) {{ acceptButtonText }}

      .footer(v-if="isCampaigns === 1 && !indexCombo && !questionData" :key="3")
        van-button.footer_another.theme_color(
          size="large"
          @click="refuseMarketing"
        ) {{ t('no_thanks', 'NO THANKS') }}

        van-button.footer_another(
          size="large"
          type="primary"
          @click="signUp"
        ) {{ t('sign_up', 'SIGN UP') }}

  van-popup(v-model="showCampaign")
    .wrapper
      icon.close_icon(size="26" @click="showCampaign = false") close

      .block(v-if="questionData && questionData.settings")
        div(v-html="questionData.settings.terms")
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import faceComponents from './components/faceComponents'
import numberComponents from './components/numberComponents'
import starComponents from './components/starComponents'
import textComponents from './components/textComponents'
import campaignComponents from './components/campaignComponents'
import marketingComponents from './components/marketingComponents'
import { mapState } from 'vuex'
import { campaignFailTab, campaignLastSurvey, campaignMainTab, campaignTab } from 'utils/message'
import { answerCampaign } from 'api/product'
import { MessageDialog } from '@/plugins/createPcApi'
import dayjs from 'dayjs'
import resizeHandler from 'utils/resizeHandler'
import { getLocalizedCampaignField, t } from '@/utils/language'

@Component({
  props: {
    showSurveys: Boolean, // Whether pop-up window is displayed   // 是否展示弹窗
    data: Array, // Feedback list data   // 反馈列表数据
    isCampaigns: Number, // 0: Do not display 1: Marketing+feedback 2: Marketing 3: Feedback   // 0: 不显示  1: 营销+反馈  2: 营销  3: 反馈
    imgSrc: String, // Email marketing, showing the picture path   // 邮件营销，展示图片路径
    marketingConsentMessage: String, // Email marketing, display copy   // 邮件营销，展示文案
    messageList: Object, // all other messages
    orderId: String,
    fullScreen: Boolean,
    alwaysShowHeader: {
      type: Boolean,
      default: false
    },
    bottomButtonStyle: {
      type: String,
      default: ''
    },
    isDisableButton: Boolean // Whether to disable the button   // 是否禁用按钮
  },

  components: {
    faceComponents,
    numberComponents,
    starComponents,
    textComponents,
    campaignComponents,
    marketingComponents
  },

  computed: {
    ...mapState({
      currentLanguage: state => state.language?.currentLanguage,
      venueId: state => state.venueId,
      userInfo: state => state.contactDetails.user,
      venueName: state => state.checkinInfo.name,
    }),

    /**
     * @return {String} Button Copy
     */
    /**
     * @return {String} 按钮文案
     */
    buttonText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      let text = t('next', 'NEXT')
      if (this.componentNameArrLength === 1) text = t('submit', 'SUBMIT')
      else if (this.componentNameArrLength === (this.indexCombo + 1)) text = t('finish', 'FINISH')
      return text
    },

    /**
     * @return {String} Reject Button Copy
     */
    /**
     * @return {String} 拒绝按钮文案
     */
    rejectButtonText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const text = getLocalizedCampaignField(this.questionData, 'rejectText')
      return text || t('no_thanks', 'NO THANKS')
    },

    /**
     * @return {String} Accept Button Copy
     */
    /**
     * @return {String} 接受按钮文案
     */
    acceptButtonText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const text = getLocalizedCampaignField(this.questionData, 'acceptText')
      return text ? text.toUpperCase() : t('next', 'NEXT')
    },

    // Google Review 英雄区版式(thirdPartyReview + layout=googleReviewHeroV1)才用新 header / 按钮
    isReviewHero() {
      const c = this.questionData?.settings?.campaign
      return c?.type === 'thirdPartyReview' && c?.layout === 'googleReviewHeroV1'
    },

    // 第三方评价顶部 header 文案;可由 settings.campaign.headerText 覆盖,缺省 "Thank you for your support!"
    reviewHeaderText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return this.questionData?.settings?.campaign?.headerText || t('thank_you_for_support', 'Thank you for your support!')
    },

    // 第三方评价按钮文案(不大写,保留 "Review us on" 这类原样)
    reviewBtnText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.questionData, 'acceptText') || t('review_us_on', 'Review us on')
    },

    // Get localized optinText for campaign popup / 获取本地化的 optinText
    // Preserve `false` value — it signals "skip popup, go directly to next optinCampaign"
    // 保留 `false` 值 — 表示"跳过弹窗，直接进入下一个 optinCampaign"
    localizedOptinText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const raw = this.questionData?.optinText
      if (raw === false) return false
      return getLocalizedCampaignField(this.questionData, 'optinText')
    },

    // Get localized optinTitle for campaign popup / 获取本地化的 optinTitle
    localizedOptinTitle() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.questionData, 'optinTitle')
    },

    // Determine how much each increase of the progress bar should increase
    // 判断出进度条的每次增加，应该增加几
    progressNum() {
      return Math.ceil(100 / this.componentNameArr.length)
    },

    // Judge whether the next button is disabled. Disabled if the page type is survey and no question type is selected
    // 判断下一步按钮，是否禁用。如果页面类型是 survey，并且没有选中任何题型的时候，禁用
    disabled() {
      const type = this.questionData?.type ?? 'survey'
      const index = this.isSelected
      let pass = false
      if (Array.isArray(index)) {
        pass = !index.length
      } else {
        pass = index === null
      }
      return (pass && type === 'survey')
    },

    labelBoxHeight() {
      // When managing the background preview mode, a fixed value is returned
      // 管理后台的预览模式时，返回固定的数值
      if (this.$route.query.isIframeCondition) return this.isMobile ? '122px' : '117PX'
      return this.componentNameArrLength === 1 ? this.boxHeight + 'px' : this.boxHeight - 16 + 'px'
    },
  },

  watch: {
    showSurveys: {
      handler(newName) {
        // In particular, you cannot use arrow functions, arrow functions, this points to the global
        // 特别注意，不能用箭头函数，箭头函数，this指向全局
        if (newName) {
          this._initData()
        }
      },
      immediate: true // Refresh load. Trigger the handler immediately   // 刷新加载。立马触发一次 handler
    },

    showComponentBox: {
      handler(newName) {
        this.$nextTick(_ => {
          // In addition to email marketing, submit the interface when viewing feedback
          // 除邮件营销以外，查看反馈时，提交接口
          if (this.componentsName !== 'marketing') this._answerCampaign('view', false)
          // Clear component data when switching components
          // 切换组件时，清空组件数据
          if (this.$refs.component._initializationData) this.$refs.component._initializationData()
        })
      },
      immediate: true
    }
  }
})

class FeedbackStatistics extends mixins(resizeHandler) {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  indexCombo = 0 // The current page is in the subscript of the title list   // 当前页，在题目列表的下标
  progressTotal = 0 // Percentage of header progress bar   // 头部进度条的百分比
  componentsName = '' // The title of the question type on the current page   // 当前页的题型名称
  questionData = null // Related data of the current page   // 当前页的相关数据
  componentNameArr = [] // List of question type names   // 题型名称列表
  componentNameArrLength = 0 // Length of question type name list   // 题型名称列表的长度
  isShow = true // Control QUESTION Digital Animation   // 控制 QUESTION 数字动画
  isSelected = null // Variables to determine whether the current page question type is selected   // 判断当前页面题型是否被选中的变量
  boxHeight = 0 // labelBox height   // labelBox 高度
  showCampaign = false // Whether the activity page pops up   // 活动页面是否弹出
  showComponentBox = true // Control question type content animation   // 控制题型内容动画
  hasCampaign = false // Is it an affiliate ad   // 是否有关联广告
  isRelationCampaign = false // Is it an affiliate ad   // 是否是关联广告
  // showMessageList = { title: 'Thank you for your order!', titleLong: 'While we prepare your order, please take a moment to answer the following questions.' }
  showMessageList = { title: t('thank_you_for_order', 'Thank you for your order!'), titleLong: ' ' }
  dataList = false

  mounted() {
    // Height of labelBox under the first page loading assignment
    // 页面第一次加载赋值下 labelBox 高度
    this.boxHeight = this.$refs.labelBox?.offsetHeight ?? 0
    if (this.messageList) {
      this.showMessageList = {
        ...this.showMessageList,
        ...this.messageList
      }
    }
    if (this.data[0]) {
      const localizedTitle = getLocalizedCampaignField(this.data[0], 'logoTitle')
      if (localizedTitle) {
        this.showMessageList.title = localizedTitle
      }
      const localizedTitleLong = getLocalizedCampaignField(this.data[0], 'logoTitleLong')
      if (localizedTitleLong) {
        this.showMessageList.titleLong = localizedTitleLong
      }
    }
    if (this.dataList === false) this.dataList = this.data
    this._setVh()
  }

  /**
   * Click Next
   * @param optin {Boolean} Click the Confirm or Cancel button
   */
  /**
   * 点击下一页
   * @param optin {Boolean} 点击确认还是取消按钮
   */
  async switchComponent(optin = true) {
    if (this.isDisableButton) return
    // Whether it is a pop-up window of email marketing
    // 是否是邮件营销弹窗
    const isMarketing = this.componentsName === 'marketing'
    const type = this.questionData?.type ?? 'survey'
    const isThirdPartyReview = this.questionData?.settings?.campaign?.type === 'thirdPartyReview' && this.questionData?.settings?.campaign?.externalUrl
    // Whether to submit through API
    // 是否通过 API 提交
    let isSuccess = true
    if (this.isSelected === null && type === 'survey' && !isMarketing) return
    // 第三方评价:accept 时打开评价链接。必须在 await 之前同步调用 window.open 以保留用户手势
    // (iOS Safari/WebKit 对手势要求严格,await 之后再 open 会被弹窗拦截);先打开,再提交统计。
    const reviewUrl = this.questionData?.settings?.campaign?.externalUrl
    let reviewWin = null
    if (isThirdPartyReview && optin === true && reviewUrl) {
      reviewWin = window.open(reviewUrl, '_blank')
    }
    if (!isMarketing) {
      if (this.isMobile) {
        this.$store.commit('showLoading')
      } else {
        this.$emit('showLoading')
      }
      isSuccess = await this._answerCampaign('answer', optin)
      if (this.isMobile) {
        this.$store.commit('closeLoading')
      } else {
        this.$emit('closeLoading')
      }
    }
    // 内嵌浏览器(微信/Teams 等 App 内置 WebView,没有多标签)里 window.open 会返回 null、
    // 不弹新标签 → 用当前页跳转兜底,保证"点了有反应"(代价:用户需手动点返回键回到订单页)。
    if (isThirdPartyReview && optin === true && reviewUrl && !reviewWin) {
      window.location.href = reviewUrl
    }

    // Failed to submit through API, pop up and terminate the operation
    // 没通过 API 提交，出现弹窗，并终止运行
    if (!isSuccess) this.focusDialog('fail')
    if (!isSuccess) return
    // When there are options associated with ads
    // 有选项有关联广告的情况
    if (this.hasCampaign && !Array.isArray(this.hasCampaign)) {
      this.componentsName = this.hasCampaign.type
      this.questionData = this.hasCampaign
      this.isSelected = null // Whether to select question type variable reset   // 是否选择题型变量重置
      this.showComponentBox = !this.showComponentBox
      this.hasCampaign = false
      this.isRelationCampaign = true
      return
    }
    // Check whether the campaign is associated with campaigns
    // 检查 campaign 是否有关联 campaigns
    if (optin === true && type === 'campaign' && this.questionData?.settings?.campaign?.optinCampaigns) {
      this.dataList = [
        ...this.questionData.settings?.campaign?.optinCampaigns,
        ...this.dataList.slice(1)
      ]
      this._initData()
      // this.componentsName = this.questionData.settings?.campaign?.optinCampaigns[0].type
      // this.questionData = this.questionData.settings?.campaign?.optinCampaigns[0]
      this.isSelected = null // Whether to select question type variable reset   // 是否选择题型变量重置
      this.showComponentBox = !this.showComponentBox
      this.hasCampaign = false
      this.isRelationCampaign = true
      // this.orderId = Math.random() // test prop is updated or not
      return
    }

    this.isRelationCampaign = false
    if (this.indexCombo < this.componentNameArr.length - 1) {
      // Determine whether the segment is greater than the length of indexCombo componentNameArr array
      // 判断是否大于了 indexCombo componentNameArr 数组的长度
      this.indexCombo++ // Click once and add once   // 点击一次，indexCombo 加一次
      this.componentsName = this.componentNameArr[this.indexCombo] // Get component prefix   // 获取组件前缀
      const index = this.indexCombo + 1 // Increase the large progress of the progress bar   // 增加进度条的进度
      const dataIndex =
      this.isCampaigns === 1 ? this.indexCombo - 1 : this.indexCombo // When isCampaigns is equal to 1, indexCombo needs to subtract 1   // isCampaigns 等于 1 的时候，indexCombo 需要减 1
      this.progressTotal = Math.ceil(this.progressNum * index) // Get percentage of progress bar   // 获取进度条的百分比
      this.questionData = this.dataList[dataIndex] // Get the data of the corresponding component   // 获取对应组件的数据
      this.isShow = !this.isShow // Digital animation switching   // 数字动画切换
      this.isSelected = null // Whether to select question type variable reset   // 是否选择题型变量重置
      this.hasCampaign = false
      this.showComponentBox = !this.showComponentBox
    } else if (this.indexCombo === this.componentNameArr.length - 1) {
      if (this.questionData?.type === 'survey') {
        // survey 项顶层无 thankyouText,回退读 settings.thankyouText(低分自定义感谢文案)
        this.focusDialog('lastSurvey', getLocalizedCampaignField(this.questionData, 'thankyouText') || this.questionData?.settings?.thankyouText)
      } else {
        this.$emit('closeDialog')
      }
    } else {
      this.indexCombo = this.componentNameArr.length - 1 || 1 // If the length of componentNameArr array is exceeded, always assign the length of componentNameArr array   // 如果超出了 componentNameArr 数组长度，则一直赋值 componentNameArr 数组长度
    }
  }

  /**
   * Check Feedback Options
   * @param value {String, Number} Option value
   * @param hasCampaign {Boolean} Whether there are associated advertisements
   */
  /**
   * 选中反馈选项
   * @param value {String, Number} 选项值
   * @param hasCampaign {Boolean} 是否存在关联广告
   */
  event(value, hasCampaign = false) {
    this.hasCampaign = hasCampaign
    this.isSelected = value
  }

  openCampaign(open) {
    this.showCampaign = open
  }

  // Reject email marketing
  // 拒绝邮件营销
  refuseMarketing() {
    if (this.isDisableButton) return
    const nowTime = dayjs.tz().format('YYYY-MM-DD')
    const { venueId } = this
    this.$store.commit('signUpDialogOnceTime/SET_SIGN_UP_POPUP_ONCE_TIME', { nowTime, venueId })
    this.switchComponent()
  }

  // The campaign component appears. When you click Attention, a pop-up function appears
  // 出现 campaign 组件，点击关注的时候就会出现一个弹窗函数
  focusDialog(val, thankyouText = '', thankyouTitle = '') {
    if (this.isDisableButton) return
    const self = this
    const messageObj = {
      campaign: campaignTab(this.userInfo?.email ?? '', thankyouText, thankyouTitle),
      main: campaignMainTab(),
      fail: campaignFailTab(),
      lastSurvey: campaignLastSurvey(thankyouText)
    }
    // Determine whether it is the mobile terminal
    // 判断是不是手机端
    if (this.isMobile) {
      if (thankyouText === false || this.questionData?.settings?.campaign?.type === 'thirdPartyReview') {
        // do not display this
        this.switchComponent()
      } else {
        this.$createTabMessageDialog({
          $props: messageObj[val],
          $events: {
            click() {
              self.showManageTabDialog = true
              // When interface error pops up, the operation is terminated
              // 是接口报错弹窗时，终止运行
              if (val === 'fail') return
              if (val === 'lastSurvey') {
                self.$emit('closeDialog')
                return
              }
              self.switchComponent()
            },
          },
        }).show()
      }
    } else {
      if (thankyouText === false || this.questionData?.settings?.campaign?.type === 'thirdPartyReview') {
        // do not display this
        this.switchComponent()
      } else {
        MessageDialog.$create({
          $props: messageObj[val],
          $events: {
            click() {
              self.showManageTabDialog = true
              // When interface error pops up, the operation is terminated
              // 是接口报错弹窗时，终止运行
              if (val === 'fail') return
              if (val === 'lastSurvey') {
                self.$emit('closeDialog')
                return
              }
              self.switchComponent()
            },
          },
        }).show()
      }
    }
  }

  // Join Email Marketing
  // 加入邮件营销
  signUp() {
    this.$emit('signUp')
    this.focusDialog('main')
  }

  _initData() {
    this.componentNameArr = this._setData()
    this.progressTotal = this.progressNum
    this.componentsName = this.componentNameArr[0]
    if (this.isCampaigns !== 1) this.questionData = this.dataList !== false ? this.dataList[0] : this.data[0]
  }

  _setData() {
    if (this.dataList === false) {
      this.dataList = this.data
    }
    if (!this.dataList) return []

    // Expand surveyList type: replace it with its optinCampaigns (like inline expansion)
    // 展开 surveyList 类型：用其 optinCampaigns 替换（类似内联展开）
    const expandedList = []
    this.dataList.forEach(item => {
      if (item.type === 'surveyList' && item.settings?.campaign?.optinCampaigns?.length) {
        expandedList.push(...item.settings.campaign.optinCampaigns)
      } else {
        expandedList.push(item)
      }
    })
    this.dataList = expandedList

    const nameArr = this.dataList.map(item => {
      return item.type !== 'campaign' ? item.settings?.survey?.iconType : item.type
    })

    if (this.isCampaigns === 1) nameArr.unshift('marketing')
    this.componentNameArrLength = nameArr.length
    return nameArr
  }

  _closeAnswerCampaign() {
    this._answerCampaign('close', false)
  }

  /**
   * Submit feedback results
   * @param action {String} Submission Type
   * @param optin {Boolean} Click the Confirm or Cancel button
   * @return {Boolean} Whether to submit for approval
   */
  /**
   * 提交反馈结果
   * @param action {String} 提交类型
   * @param optin {Boolean} 点击确认还是取消按钮
   * @return {Boolean} 是否提交通过
   */
  async _answerCampaign(action, optin) {
    // When you are in management background preview mode, do not execute the following code
    // 管理后台的预览模式时，不执行下面代码
    if (this.$route.query.isIframeCondition) return
    const userId = localStorage.getItem('userId')
    const {
      email,
      name,
      phone
    } = this.userInfo
    const id = this.componentsName === 'marketing' ? 'marketing' : this.questionData.id
    const type = this.questionData?.type ?? ''
    let step = this.componentNameArr.find(item => item === 'marketing') ? this.indexCombo : this.indexCombo + 1
    if (this.isRelationCampaign) step += 0.1 // If it is a related advertisement, 0.1 should be added   // 若现在是关联广告，需要加 0.1
    const data = {
      userId,
      campaignAnswer: {
        id,
        email,
        name,
        phone,
        userId,
        venueId: this.venueId,
        venueName: this.venueName,
        campaign: {
          id,
          name: this.questionData?.name ?? '',
          type,
          questionType: this.questionData?.settings?.survey?.questionType ?? '',
          surveyType: this.questionData?.settings?.survey?.type ?? '',
          iconType: this.questionData?.settings?.survey?.iconType ?? '',
        },
        answer: this.isSelected,
        optin,
        action,
        step,
        timestamp: dayjs.tz().format('YYYY-MM-DD HH:mm:ss'),
      }
    }
    let isSuccess = true
    await answerCampaign(data).catch(_ => {
      isSuccess = false
      this.$store.commit('closeLoading')
    })
    return isSuccess
  }

  // Set sass variable: vh
  // 设置 sass 变量：vh
  _setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }
}
export default FeedbackStatistics
</script>
